export default __webpack_public_path__ + "static/fall14-c72c9d43c1de1c15629b97445ea4c58a.webp";